var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-popup',{staticClass:"croper-popup",attrs:{"active":_vm.cropper.show,"buttons-hidden":true},on:{"update:active":function($event){return _vm.$set(_vm.cropper, "show", $event)},"close":_vm.cancelCropper}},[_c('div',{staticClass:"main-title ml-1"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Crop Image')))])]),_c('div',{staticClass:"relative mt-8"},[_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"src":_vm.cropper.initialImg,"default-size":_vm.cropper.defaultSize,"resizeImage":false,"stencil-props":{
        movable: true,
        resizable: false,
        aspectRatio: 16 / 9,
        handlers: {
          eastNorth: false,
          north: false,
          westNorth: false,
          west: false,
          westSouth: false,
          south: false,
          eastSouth: false,
          east: false
        }
      }},on:{"change":_vm.onChange}})],1),_c('section',{staticClass:"text-right space-x-3 croper-actions actions mt-8"},[_c('button',{staticClass:"croper-cancel-action action-cancel",on:{"click":_vm.cancelCropper}},[_vm._v("\n      "+_vm._s(_vm.$t('Cancel'))+"\n    ")]),_c('button',{staticClass:"croper-apply-action action-submit",attrs:{"type":"filled"},on:{"click":_vm.applyCropper}},[_vm._v("\n      "+_vm._s(_vm.$t('Apply'))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }